module.exports = __webpack_public_path__ + "static/media/goldmansachs_logo.03b83a43.svg";